import { render, staticRenderFns } from "./PrintBody.vue?vue&type=template&id=68b9eeae&scoped=true"
import script from "./PrintBody.vue?vue&type=script&lang=js"
export * from "./PrintBody.vue?vue&type=script&lang=js"
import style0 from "./PrintBody.vue?vue&type=style&index=0&id=68b9eeae&prod&scoped=true&lang=css"
import style1 from "./PrintBody.vue?vue&type=style&index=1&id=68b9eeae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9eeae",
  null
  
)

export default component.exports